import React, { useState } from "react";
import InfoRounded from '@mui/icons-material/InfoRounded';
import { PhoneInput as ReactInternationalPhone } from 'react-international-phone';
import 'react-international-phone/style.css';

const PhoneInput = ({ value, onInput, label = "Telefone", placeholder = "", variant = 'light', disabled, error, helper, fullWidth, className, ...props }) => {
    return (
        <div className={
            `CustomInput_container 
            ${disabled ? 'disabled' : ''}
            ${error ? 'error' : ''}
            ${className || ''}
            ${variant === 'large' ? 'large' : 'small'}
            ${fullWidth ? 'full-width' : ''}
            `} style={{ position: "relative" }}>

            {label && (
                <span className="CustomInput_label">
                    {label}
                </span>
            )}

            <ReactInternationalPhone
                defaultCountry="br"
                value={value}
                onChange={(phone) => onInput && onInput(phone)}
                disabled={disabled}
                placeholder={placeholder}
                className="CustomInput_platform-input-base phone-plugin-wrapper"
                inputClassName={`custom-input custom-input-${variant} phone-plugin-input`}
                countrySelectorStyleProps={{
                    buttonClassName: 'phone-plugin-button'
                }}
            />

            {helper && (
                <div className="CustomInput_bottom">
                    <span className="CustomInput_helper">
                        <InfoRounded />
                        <span>{helper}</span>
                    </span>
                </div>
            )}
        </div>
    );
};

export default PhoneInput;
